// extracted by mini-css-extract-plugin
export default {"modal":"PrivacyPopup_modal__i3UpB","overlay":"PrivacyPopup_overlay__y-MQY"};